// 検索タグ
const Tag = {
  namespaced: true,

  state: {
    tag: [],
  },
  getters: {
    getTag: state => {
      return state.tag
    },
  },
  mutations: {
    setTag(state, tag) {
      state.tag = tag
    },
  },
  actions: {
    reset({ commit }) {
      commit('setTag', [])
    },
  },
}

export default Tag
